import React, { useEffect } from 'react';
import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';
import { insuranceModStyles } from './InsuranceMod.styles';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { useSelector } from 'react-redux';
import { selectEffectiveTypeValue } from 'store/redux-store/placement-mods/selectors';

export const InsuranceCustomDate = ({ isModEdit }: { isModEdit: boolean }) => {
  const { control, formState: { errors }, clearErrors, trigger } = useFormContext();
  const value: any = useWatch({ name: 'insuranceCustomDate' });
  const { classes } = insuranceModStyles();
  const effectiveTypeValue = useSelector(selectEffectiveTypeValue);

  const checkDateValidation = date => {
    if (!date || date.toString().length === 0) return 'Required';
    clearErrors('insuranceCustomDate');
    return null;
  };

  useEffect(() => {
    if (parseInt(effectiveTypeValue) === 2) {
      trigger('insuranceCustomDate');
    } else {
      clearErrors('insuranceCustomDate');
    }
  }, []);

  return (
    <Controller
      control={control}
      name={'insuranceCustomDate'}
      rules={{
        validate: checkDateValidation,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const insuranceCustomDate = moment(value ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                } else {
                  onChange(null);
                }
              }}
              value={value}
              onCancel={() => {}}
              clear
              open={false}
              variant="filled"
              single
              placeholder="Custom Date*"
              labelClass={classes.inputFields}
              className={classes.inputFields}
              quickSelect={false}
              useMaxWidth={true}
              showIcon={true}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={!isModEdit}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: insuranceCustomDate.isValid()
                  ? new Date(insuranceCustomDate.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                endDate: insuranceCustomDate.isValid()
                  ? new Date(insuranceCustomDate.format('YYYY-MM-DDTHH:mm:ss'))
                  : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.insuranceCustomDate)}
              helperText={
                !isNullOrUndefined(errors?.insuranceCustomDate) ? errors?.insuranceCustomDate?.message : undefined
              }
            />
          </React.Fragment>
        );
      }}
    />
  );
};
